module.exports = __webpack_public_path__ + "static/media/this-site.406f508a.png";